import React from 'react'
import { useIntl } from 'react-intl'
import type { FieldsConfiguration } from 'msp-components'
import { useConfig, useMultiSite } from 'msp-integrations'

export const newsletterCheckboxLabel = () => {
  const { formatMessage } = useIntl()
  const { buildUrl } = useMultiSite()
  const { titleNewsletter } = useConfig()
  return formatMessage(
    {
      defaultMessage:
        'By submitting the form, you consent to receiving the {title} News Service via email. Your consent also includes data processing outside the European Economic Area, particularly in the USA, in accordance with Art. 45, 46, or 49 (1) lit. a GDPR. You can withdraw your consent at any time free of charge with effect for the future. No additional costs will be incurred, except for the transmission costs according to the basic rates of your internet connection. You can unsubscribe at any time under "Data Releases" in your account settings or via the unsubscribe link at the end of each newsletter. We use URL tracking to analyze click and open rates. You can find our privacy policy {privacyPolicyLink}.',
      id: 'msp.newsletter_form.label.subscribe_darq_newsletter'
    },
    {
      title: titleNewsletter || '',
      privacyPolicyLink: (
        <a
          href={`${buildUrl(
            formatMessage({
              id: 'msp.newsletter_form.privacyPolicyUrl',
              defaultMessage: '/privacy'
            })
          )}`}
          target='blank'
          className='underline'
        >
          {formatMessage({
            id: 'msp.newsletter_form.link',
            defaultMessage: 'here'
          })}
        </a>
      )
    }
  )
}

const getNewsletterFields = (id: string = ''): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    firstName: {
      id: 'firstName',
      type: 'text',
      name: 'firstName',
      placeholder: formatMessage({
        defaultMessage: 'First name',
        id: 'msp.newsletter_form.label.first_name'
      }),
      label: ''
    },
    lastName: {
      id: 'lastName',
      type: 'text',
      name: 'lastName',
      placeholder: formatMessage({
        defaultMessage: 'Last name',
        id: 'msp.newsletter_form.label.last_name'
      }),
      label: ''
    },
    email: {
      id: 'email',
      type: 'email',
      name: 'email',
      placeholder: formatMessage({
        defaultMessage: 'your@email.com*',
        id: 'msp.newsletter_form.label.email'
      }),
      label: '',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your email address.',
          id: 'msp.newsletter_form.error.required_email'
        })
      }
    },
    [`newsletter_${id}`]: {
      id: `newsletter_${id}`,
      type: 'checkbox',
      name: `newsletter_${id}`,
      placeholder: '',
      label: newsletterCheckboxLabel(),
      rules: {
        required: formatMessage({
          defaultMessage: 'You must select this checkbox.',
          id: 'msp.newsletter_form.error.required_terms_acceptance'
        })
      }
    }
  }
}

export default getNewsletterFields
